import DescriptionApi from '../../api/gen/extObjekty/DescriptionApi';
import {CachingLoader} from '../../utils';

function loadDescription(feature) {
    return DescriptionApi.describeGeometry(feature.geometry);
}

/**
 * Utilita pro načtení popisu umístění na základě geometrických dat zákresu.
 */
export default class DescriptionLoader {

    /**
     * Konstruktor.
     *
     * @param {Object} [options] - volitelné parametry
     * @param {function} [options.onLoadStateChange] - callback volaný při změně stavu načítání položek
     * @param {number} [options.loadDelay] - spoždění načítání (debounce)
     */
    constructor(options) {
        this.loader = new CachingLoader(loadDescription, options);
    }

    /**
     * Spustí načítání.
     *
     * @param {Array<Object>} features - pole features ze kterých se získají geometrická data
     * @param {boolean} [options.reloadErrors=false] -  příznak, zda vynutit opětovné načtení položek v cache,
     *                                                  u nichž skončilo přechozí načítání chybou
     */
    loadDescriptions(features, options) {
        this.loader.loadItems(features, options);
    }

    /**
     * Otestuje, zda právě probíhá načítání.
     *
     * @returns {boolean} true, pokud se načítá alespoň jedna položka, jinak false
     */
    isLoading() {
        return this.loader.isLoading();
    }

    /**
     * Vrátí řetězec obsahující zkombinované "krátké" popisy jednotlivých geometrických dat.
     *
     * @returns {string} výsledný řetězec
     */
    getLoadedShortDescriptionsAsString() {
        const kuToUliceSet = {};

        for (const {shortDescriptions} of this.loader.getLoadedData()) {
            for (const {ku, ulice} of shortDescriptions) {
                if (kuToUliceSet[ku] == null) {
                    kuToUliceSet[ku] = new Set();
                }
                kuToUliceSet[ku].add(ulice);
            }
        }

        const resultParts = [];

        for (const [ku, uliceSet] of Object.entries(kuToUliceSet)) {
            const ulice = Array.from(uliceSet).join(', ');
            resultParts.push(`${ulice} (k.ú. ${ku})`);
        }

        return resultParts.join('; ');
    }

    /**
     * Vrátí řetězec obsahující zkombinované "dlouhé" popisy jednotlivých geometrických dat.
     *
     * @returns {string} výsledný řetězec
     */
    getLoadedLongDescriptionsAsString() {
        const resultParts = new Set();

        for (const {longDescriptions} of this.loader.getLoadedData()) {
            for (const description of longDescriptions) {
                resultParts.add(description);
            }
        }

        return Array.from(resultParts).join(', ');
    }

}
